import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Meet the Shame",
    opening: localizedGenderNode(
      [
      "Today I don't push myself to speak.",
      "I just notice: there is shame in me in front of an audience.",
      "One breath."
    ],
      [
      "Today I don't push myself to speak.",
      "I just notice: there is shame in me in front of an audience.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happens in me when I think about speaking in front of others?",
      "What do I fear they will see in me?",
      "What do I need to hear from myself now?"
    ],
      [
      "What happens in me when I think about speaking in front of others?",
      "What do I fear they will see in me?",
      "What do I need to hear from myself now?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "When I name it, it feels less overwhelming."
    ],
      [
      "When I name it, it feels less overwhelming."
    ]
    ),
    action: localizedGenderNode(
      "I tell myself quietly \"I am with me.\"",
      "I tell myself quietly \"I am with me.\""
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The First Moment",
    opening: localizedGenderNode(
      [
      "Today I notice the first moment before I need to speak.",
      "I do not move ahead. I only notice.",
      "One breath."
    ],
      [
      "Today I notice the first moment before I need to speak.",
      "I do not move ahead. I only notice.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When is it strongest? (before a meeting / during a meeting)",
      "What is the first thing I feel in my body?",
      "What is the first thought that jumps in?"
    ],
      [
      "When is it strongest? (before a meeting / during a meeting)",
      "What is the first thing I feel in my body?",
      "What is the first thought that jumps in?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "The first moment is a small crack of choice."
    ],
      [
      "The first moment is a small crack of choice."
    ]
    ),
    action: localizedGenderNode(
      "when it rises, I pause for two breaths.",
      "when it rises, I pause for two breaths."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "My Body",
    opening: localizedGenderNode(
      [
      "Today I give my body one word.",
      "No judgment. Only description.",
      "One breath."
    ],
      [
      "Today I give my body one word.",
      "No judgment. Only description.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does it sit in my body? (belly / chest / throat)",
      "What is my body trying to do for me?",
      "What small softening can I give it?"
    ],
      [
      "Where does it sit in my body? (belly / chest / throat)",
      "What is my body trying to do for me?",
      "What small softening can I give it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "My body is not against me. It is trying to protect."
    ],
      [
      "My body is not against me. It is trying to protect."
    ]
    ),
    action: localizedGenderNode(
      "hand on my chest for ten seconds.",
      "hand on my chest for ten seconds."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "The Story in My Head",
    opening: localizedGenderNode(
      [
      "Today I separate what happens from what I tell myself.",
      "I see the story.",
      "One breath."
    ],
      [
      "Today I separate what happens from what I tell myself.",
      "I see the story.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What story do I tell about speaking in front of people?",
      "What meaning do I give to silence or a look?",
      "What softer possibility exists?"
    ],
      [
      "What story do I tell about speaking in front of people?",
      "What meaning do I give to silence or a look?",
      "What softer possibility exists?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A story is not a fact."
    ],
      [
      "A story is not a fact."
    ]
    ),
    action: localizedGenderNode(
      "I tell myself \"this is a story, not certainty.\"",
      "I tell myself \"this is a story, not certainty.\""
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Triggers",
    opening: localizedGenderNode(
      [
      "Today I notice what triggers the shame.",
      "It is knowledge, not blame.",
      "One breath."
    ],
      [
      "Today I notice what triggers the shame.",
      "It is knowledge, not blame.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What kind of room, person, or look activates me?",
      "What makes it stronger?",
      "What softens it even a little?"
    ],
      [
      "What kind of room, person, or look activates me?",
      "What makes it stronger?",
      "What softens it even a little?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "When I know a trigger, I am less surprised."
    ],
      [
      "When I know a trigger, I am less surprised."
    ]
    ),
    action: localizedGenderNode(
      "I pick one trigger and look at it without running.",
      "I pick one trigger and look at it without running."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "My Pattern",
    opening: localizedGenderNode(
      [
      "Today I look at my pattern before I speak.",
      "No criticism.",
      "One breath."
    ],
      [
      "Today I look at my pattern before I speak.",
      "No criticism.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I do to protect myself in a meeting?",
      "What is the cost of that protection?",
      "What could be a little different?"
    ],
      [
      "What do I do to protect myself in a meeting?",
      "What is the cost of that protection?",
      "What could be a little different?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small change is enough to loosen a loop."
    ],
      [
      "A small change is enough to loosen a loop."
    ]
    ),
    action: localizedGenderNode(
      "I allow myself a small change once.",
      "I allow myself a small change once."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Fear of Judgment",
    opening: localizedGenderNode(
      [
      "Today I touch the fear beneath the shame.",
      "I stay with it for a moment.",
      "One breath."
    ],
      [
      "Today I touch the fear beneath the shame.",
      "I stay with it for a moment.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I fear they will think about me?",
      "What inner sentence rises in me?",
      "What would help me feel a little safer?"
    ],
      [
      "What do I fear they will think about me?",
      "What inner sentence rises in me?",
      "What would help me feel a little safer?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Fear of judgment is a need for safety."
    ],
      [
      "Fear of judgment is a need for safety."
    ]
    ),
    action: localizedGenderNode(
      "I notice the fear without fighting it.",
      "I notice the fear without fighting it."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "The Critical Voice",
    opening: localizedGenderNode(
      [
      "Today I notice the voice that criticizes me before I speak.",
      "I listen without believing it.",
      "One breath."
    ],
      [
      "Today I notice the voice that criticizes me before I speak.",
      "I listen without believing it.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does the critical voice say to me?",
      "What word does it use about me?",
      "What gentle voice could answer it?"
    ],
      [
      "What does the critical voice say to me?",
      "What word does it use about me?",
      "What gentle voice could answer it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A critical voice is a frightened voice."
    ],
      [
      "A critical voice is a frightened voice."
    ]
    ),
    action: localizedGenderNode(
      "one gentle sentence to myself.",
      "one gentle sentence to myself."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Inner Boundary",
    opening: localizedGenderNode(
      [
      "Today I set an inner boundary before I speak.",
      "To keep myself safe.",
      "One breath."
    ],
      [
      "Today I set an inner boundary before I speak.",
      "To keep myself safe.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is not ok for me in professional spaces?",
      "How does my body signal that it's too much?",
      "What inner boundary can I set without words?"
    ],
      [
      "What is not ok for me in professional spaces?",
      "How does my body signal that it's too much?",
      "What inner boundary can I set without words?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "An inner boundary creates breathing room."
    ],
      [
      "An inner boundary creates breathing room."
    ]
    ),
    action: localizedGenderNode(
      "I remind myself of that boundary before a meeting.",
      "I remind myself of that boundary before a meeting."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "What I Need",
    opening: localizedGenderNode(
      [
      "Today I look for the need beneath the shame.",
      "Not a solution, only a need.",
      "One breath."
    ],
      [
      "Today I look for the need beneath the shame.",
      "Not a solution, only a need.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need to feel safer before I speak?",
      "What helps me feel steady?",
      "What small thing can I give myself?"
    ],
      [
      "What do I need to feel safer before I speak?",
      "What helps me feel steady?",
      "What small thing can I give myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "When I see a need, something calms down."
    ],
      [
      "When I see a need, something calms down."
    ]
    ),
    action: localizedGenderNode(
      "I give myself one small thing before a meeting.",
      "I give myself one small thing before a meeting."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "A Small Request",
    opening: localizedGenderNode(
      [
      "Today I form a small request to myself.",
      "No pressure.",
      "One breath."
    ],
      [
      "Today I form a small request to myself.",
      "No pressure.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small request can I ask of myself today?",
      "How does it sound when I say it softly?",
      "What will help me remember it in the moment?"
    ],
      [
      "What small request can I ask of myself today?",
      "How does it sound when I say it softly?",
      "What will help me remember it in the moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A soft request is kinder than a command."
    ],
      [
      "A soft request is kinder than a command."
    ]
    ),
    action: localizedGenderNode(
      "I repeat the request once.",
      "I repeat the request once."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Presence Before Speaking",
    opening: localizedGenderNode(
      [
      "Today I practice presence right before I speak.",
      "That is enough for today.",
      "One breath."
    ],
      [
      "Today I practice presence right before I speak.",
      "That is enough for today.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What helps me remember I am not alone inside?",
      "What small anchor can I bring with me?",
      "What do I want to remember when I speak?"
    ],
      [
      "What helps me remember I am not alone inside?",
      "What small anchor can I bring with me?",
      "What do I want to remember when I speak?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Presence is a soft shield."
    ],
      [
      "Presence is a soft shield."
    ]
    ),
    action: localizedGenderNode(
      "one anchor with me (a word / a breath / a touch).",
      "one anchor with me (a word / a breath / a touch)."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A Small Step",
    opening: localizedGenderNode(
      [
      "Today I choose a small step of speaking.",
      "Not a revolution.",
      "One breath."
    ],
      [
      "Today I choose a small step of speaking.",
      "Not a revolution.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step fits me?",
      "How will I know it was enough even if small?",
      "What do I ask of myself after it?"
    ],
      [
      "What small step fits me?",
      "How will I know it was enough even if small?",
      "What do I ask of myself after it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Small steps build trust."
    ],
      [
      "Small steps build trust."
    ]
    ),
    action: localizedGenderNode(
      "one small step, and that is enough.",
      "one small step, and that is enough."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return Sentence",
    opening: localizedGenderNode(
      [
      "Today I finish with a return sentence for hard moments.",
      "I stay with myself.",
      "One breath."
    ],
      [
      "Today I finish with a return sentence for hard moments.",
      "I stay with myself.",
      "One breath."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this shame?",
      "What helps me most right before I speak?",
      "My short return sentence is:"
    ],
      [
      "What did I learn about this shame?",
      "What helps me most right before I speak?",
      "My short return sentence is:"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can stay present for a moment before I react."
    ],
      [
      "I can stay present for a moment before I react."
    ]
    ),
    action: localizedGenderNode(
      "I say my return sentence once.",
      "I say my return sentence once."
    ),
  },
].map(buildNormalizedDay);

export const shameSpeakingAudienceWorkMeetingsBlueprintEn = buildNormalizedPilotBlueprint({
  id: "shame_speaking_audience_work_meetings_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "shame_speaking_audience_work_meetings",
  category: "anxiety",
  journeyName: {
    he: "בושה לדבר מול קהל / ישיבות עבודה",
    en: "Shame speaking in front of an audience / work meetings",
    es: "Verguenza al hablar frente a un grupo / reuniones de trabajo",
  },
  days,
});

export default shameSpeakingAudienceWorkMeetingsBlueprintEn;
